"use client"
import React, { useState } from 'react';

const DomainSearch: React.FC = () => {
  const [domainResultVisible] = useState(false);
 

  return (
    <div className="domainSec">
    <div className="container"> 
        <h1 className='text-white text-center display-5 fw-bold'>Find your domain name</h1>
        <p  className='text-white text-center fs-5 fw-normal'>Search for your dream domain now</p>

        <div className="d-flex justify-content-center">
          <div className="col-lg-9 col-md-12 col-12">
            <form
              className="domain_search"
              name="domainsearchfrm"
              id="domainsearchfrm"
              action="https://clients.temok.com/cart.php?a=add&amp;domain=register"
              method="post"
           
            >
              <div className="input-group my-3 p-2 bg-white rounded-3">
                <input
                  type="text"
                  id="domainstr2"
                  name="query"
                  className="form-control form-control-lg"
                  placeholder="Find Your Perfect Domain Name"
                  aria-label="Find Your Perfect Domain Name"
                  aria-describedby="button-addon2"
                />
                <button
                  className="btn btn-primary btnfill0"
                  data-action="submit"
                  id="search_btn"
                  type="submit"
                >
                  Search  
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {domainResultVisible && (
        <div className="result_main_area2" id="domain_result_main_area2">
          {/* Dynamic results can be displayed here */}
        </div>
      )}
    </div>
  );
};

export default DomainSearch;
